import { useQuery } from 'react-query';
import api from '../utils/api';
import type { BenchmarkGroup } from './useBenchmarks';

export interface BoatBenchmarkResponse {
  success: boolean;
  data: BenchmarkGroup | null;
  matched: 'exact' | 'fuzzy' | 'none' | 'no_benchmarks' | 'no_identity';
}

/**
 * Fetch the market-price benchmark group matched to a boat.
 * Public endpoint, no auth required. Client-side cached for 10 minutes.
 */
export function useBoatBenchmark(boatId?: number) {
  return useQuery<BoatBenchmarkResponse>(
    ['boat-benchmark', boatId],
    async () => {
      const { data } = await api.get(`/boats/${boatId}/benchmark`);
      return data;
    },
    {
      enabled: Boolean(boatId && boatId > 0),
      staleTime: 10 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    }
  );
}
